// src/components/SapDatabricksSection.tsx
import React from "react";
import SapDatabricks from "../assets/DataAnalticsBG.jpg";
import checkCircle from "../assets/Component 1.svg";

const SapDatabricksSection: React.FC = () => {
  const bulletPoints = [
    {
      title: "Seamless Integration",
      desc: "Learn how to connect SAP and Databricks for a unified data foundation",
      color: "text-blue-900",
    },
    {
      title: "AI-Ready Infrastructure",
      desc: "Enable predictive insights and advanced analytics at scale",
      color: "text-blue-900",
    },
    {
      title: "Enterprise Growth",
      desc: "Drive efficiency, innovation, and resilience across industries",
      color: "text-blue-900",
    },
  ];

  return (
    <section className="relative w-full flex justify-center items-center py-4 px-6 sm:px-12 lg:px-20 overflow-hidden">
      {/* Card container */}
      <div className="relative max-w-[1070px] lg:max-h-[925px] w-full rounded-lg overflow-hidden ">
        {/* Background image (overflow allowed, hidden outside) */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url(${SapDatabricks})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover", // prevents stretching to fit
          }}
        />
        {/* Overlay for readability */}
        {/* <div className="absolute inset-0 bg-white/90" /> */}

        {/* Content */}
        <div className="relative z-10 p-8 sm:p-12 flex flex-col gap-4 text-center">
          {/* Title with blue highlight */}
          <h2 className="inline-block max-h-[76px] bg-white text-blue-900 text-xl sm:text-2xl lg:text-4xl font-semibold font-['IBM Plex Sans'] px-4 py-2 rounded">
            Accelerate Data Analytics with SAP + Databricks
          </h2>

          {/* Subtitle */}
          <p className="self-stretch justify-start text-gray-700 lg:text-xl md:text-xl sm:text-lg xs:text-base  font-normal font-['Nunito Sans'] leading-relaxed tracking-tight text-left">
            SAP runs your most critical business processes, but unlocking that data for modern analytics and AI has been costly, slow, and siloed. Traditional ETL pipelines create multiple copies, inflate costs, and strip away valuable business context. That’s where the SAP–Databricks partnership changes the game. For the first time, you can access live, business-ready SAP data directly in the Databricks Data Intelligence Platform — without replication or complexity
          </p>

          <p className="text-gray-700 lg:text-xl md:text-xl sm:text-lg xs:text-base font-normal font-['Nunito Sans'] leading-relaxed tracking-tight text-left">
            With Delta Sharing, you eliminate fragile pipelines and reduce TCO. Unity Catalog ensures governance and compliance across SAP and all enterprise data. Mosaic AI delivers AI and GenAI applications grounded in SAP’s rich context, preventing hallucinations and driving accurate business outcomes. And with Databricks AI/BI and SQL, teams gain real-time insights that accelerate decision-making
          </p>

          <p className="text-gray-700 lg:text-xl md:text-xl sm:text-lg xs:text-base font-normal font-['Nunito Sans'] leading-relaxed tracking-tight text-left">
            The result: lower cost, faster time-to-value, and trusted analytics at scale. Customers like Adobe and Heineken are already using SAP + Databricks to transform forecasting, supply chain optimization, and customer engagement
          </p>

          <p className="text-gray-700 lg:text-xl md:text-xl sm:text-lg xs:text-base font-normal font-['Nunito Sans'] leading-relaxed tracking-tight text-left">
            Together, SAP and Databricks turn your SAP system from a system of record into a system of intelligence powering smarter decisions, AI-driven innovation, and measurable ROI
          </p>


          {/* Bullet Points */}
          <div className="flex flex-col gap-4  bg-white p-[24px] text-left">
            {bulletPoints.map((item, idx) => (
              <div key={idx} className="flex items-start  bg-white gap-3">
                {/* Check circle image */}
                <img
                  src={checkCircle}
                  alt="check"
                  className="w-6 h-6 mt-1 object-contain"
                />
                <p className="flex-1  text-gray-800 text-sm sm:text-base lg:text-xl font-normal font-['Nunito Sans'] leading-relaxed">
                  <span className={`font-semibold ${item.color}`}>
                    {item.title}:
                  </span>{" "}
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          
          <div className="flex justify-center mt-6 w-full">
            <a
                href="https://www.databricks.com/resources/guide/exec-guide-sap-databricks?itm_data=thank-you-sapeconomist-ty1-july2025"
                target="_blank"
                rel="noopener noreferrer"
                className="w-[149px] h-[48px] flex items-center justify-center bg-blue-900 rounded text-white text-sm sm:text-base lg:text-lg font-semibold font-['Open Sans'] hover:bg-blue-800 transition"
            >
                Learn more
            </a>
          </div>         
        </div>
      </div>
    </section>
  );
};

export default SapDatabricksSection;
